export default "__VITE_ASSET__CX4TKRG2__"